import { createContext, useContext } from "react";
import type { HelpKey } from "../help-registry";

export interface HelpDrawerContextValue {
	/** Opens the help drawer on this entry's long explanation. */
	openHelp: (helpKey: HelpKey) => void;
}

export const HelpDrawerContext = createContext<HelpDrawerContextValue | null>(
	null
);

/** @throws outside a `HelpDrawerProvider` */
export function useHelpDrawer(): HelpDrawerContextValue {
	const context = useContext(HelpDrawerContext);

	if (!context) {
		throw new Error("useHelpDrawer must be used within a HelpDrawerProvider");
	}

	return context;
}
